module.exports = "agm-map {\n    height: 500px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/indi-store/location/store-location.component.css
// module id = ./src/app/indi-store/location/store-location.component.css
// module chunks = main